import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Briefcase, CheckCircle, DollarSign, Star, Power } from 'lucide-react';

const WorkerStats = ({
    availablity,
    handleAvailablityToggle,
    stats
}) => {
  const navigate = useNavigate();

  return (
    <>
      {/* ══ DESKTOP HEADER (hidden mobile) ══ */}
      <div className="wh-desk-header">
        <div>
          <h2 className="wh-desk-header__title">Dashbaord</h2>
          <p className="wh-desk-header__sub">Here's what's happening with your jobs today.</p>
        </div>

        {/* Desktop Activity Toggle */}
        <button
          className={`wh-availablity-toggle wh-available-toggle--desktop ${availablity ? 'wh-availablity-toggle--available' : ''}`}
          onClick={handleAvailablityToggle}
        >
          <Power size={16} />
          <span>{availablity ? 'Available' : 'Unavailable'}</span>
        </button>
      </div>

      {/* ══ CLICKABLE STATS ══ */}
      <div className="wh-stats">
        <div
          className="wh-stat wh-stat--clickable"
          style={{ '--sc': '#0491e1', '--sb': 'rgba(4,145,225,0.12)' }}
          onClick={() => navigate('/bid-jobs')}
        >
          <div className="wh-stat__icon"><Briefcase size={20} /></div>
        <strong className="wh-stat__val">
    {stats?.activeJobs ?? 0}
</strong>
          <span className="wh-stat__label">Active Jobs</span>
        </div>

        <div
          className="wh-stat wh-stat--clickable"
          style={{ '--sc': '#10b981', '--sb': 'rgba(16,185,129,0.12)' }}
          onClick={() => navigate('/bid-jobs')}
        >
          <div className="wh-stat__icon"><CheckCircle size={20} /></div>
         <strong className="wh-stat__val">
    {stats?.jobsDone ?? 0}
</strong>
          <span className="wh-stat__label">Completed</span>
        </div>

        <div
          className="wh-stat wh-stat--clickable"
          style={{ '--sc': '#f59e0b', '--sb': 'rgba(245,158,11,0.12)' }}
          onClick={() => navigate('/worker-earnings')}
        >
          <div className="wh-stat__icon"><DollarSign size={20} /></div>
          <strong className="wh-stat__val">$24.5K</strong>
          <span className="wh-stat__label">Earnings</span>
        </div>

        <div
          className="wh-stat wh-stat--clickable"
          style={{ '--sc': '#f59e0b', '--sb': 'rgba(245,158,11,0.12)' }}
          onClick={() => navigate('/worker-profile')}
        >
          <div className="wh-stat__icon"><Star size={20} /></div>
          <strong className="wh-stat__val">
    {stats?.rating ?? 0}
</strong>
          <span className="wh-stat__label">Rating</span>
        </div>
      </div>
    </>
  );
};

export default WorkerStats;